import { Breakpoint, useTheme, useMediaQuery } from '@mui/material'

const useMedia = (breakpoint: Breakpoint) => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down(breakpoint))
}

export default useMedia
